module.exports = __webpack_public_path__ + "img/iv-ezust-arany-melegfoliazasa.19cdc597.jpg";